import { render, staticRenderFns } from "./base-card.component.vue?vue&type=template&id=630598ad"
import script from "./base-card.component.ts?vue&type=script&lang=ts&external"
export * from "./base-card.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630598ad')) {
      api.createRecord('630598ad', component.options)
    } else {
      api.reload('630598ad', component.options)
    }
    module.hot.accept("./base-card.component.vue?vue&type=template&id=630598ad", function () {
      api.rerender('630598ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Card/base-card.component.vue"
export default component.exports